import { supabase } from '../lib/supabase';

/**
 * 문의사항을 저장합니다.
 * @param {Object} inquiryData - 문의사항 데이터
 * @param {string} inquiryData.message - 문의 내용
 * @param {string} inquiryData.userId - 사용자 ID (선택)
 * @param {string} inquiryData.userEmail - 사용자 이메일
 * @param {string} inquiryData.userName - 사용자 이름
 * @returns {Promise<{success: boolean, data?: any, error?: any}>}
 */
export const createInquiry = async (inquiryData) => {
  try {
    const { data, error } = await supabase
      .from('inquiries')
      .insert([
        {
          user_id: inquiryData.userId || null,
          user_email: inquiryData.userEmail,
          user_name: inquiryData.userName,
          message: inquiryData.message
        }
      ])
      .select()
      .single();

    if (error) {
      console.error('문의사항 저장 오류:', error);
      return { success: false, error };
    }

    return { success: true, data };
  } catch (error) {
    console.error('문의사항 처리 중 오류 발생:', error);
    return { success: false, error };
  }
};

/**
 * 사용자의 문의사항 목록을 조회합니다.
 * @param {string} userId - 사용자 ID
 * @returns {Promise<{success: boolean, data?: any[], error?: any}>}
 */
export const getUserInquiries = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('inquiries')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('문의사항 조회 오류:', error);
      return { success: false, error };
    }

    return { success: true, data };
  } catch (error) {
    console.error('문의사항 조회 중 오류 발생:', error);
    return { success: false, error };
  }
};

/**
 * 모든 문의사항을 조회합니다. (관리자용)
 * @returns {Promise<{success: boolean, data?: any[], error?: any}>}
 */
export const getAllInquiries = async () => {
  try {
    const { data, error } = await supabase
      .from('inquiries')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) {
      console.error('전체 문의사항 조회 오류:', error);
      return { success: false, error };
    }

    return { success: true, data };
  } catch (error) {
    console.error('전체 문의사항 조회 중 오류 발생:', error);
    return { success: false, error };
  }
};

/**
 * 문의사항 상태를 업데이트합니다. (관리자용)
 * @param {string} inquiryId - 문의사항 ID
 * @param {string} status - 새로운 상태 ('pending', 'reviewed', 'resolved')
 * @param {string} adminNotes - 관리자 메모 (선택)
 * @returns {Promise<{success: boolean, data?: any, error?: any}>}
 */
export const updateInquiryStatus = async (inquiryId, status, adminNotes = null) => {
  try {
    const updateData = { status };
    if (adminNotes !== null) {
      updateData.admin_notes = adminNotes;
    }

    const { data, error } = await supabase
      .from('inquiries')
      .update(updateData)
      .eq('id', inquiryId)
      .select()
      .single();

    if (error) {
      console.error('문의사항 상태 업데이트 오류:', error);
      return { success: false, error };
    }

    return { success: true, data };
  } catch (error) {
    console.error('문의사항 상태 업데이트 중 오류 발생:', error);
    return { success: false, error };
  }
};
